import { lazy, type ComponentType } from "react";

/**
 * Charge un écran à la demande.
 *
 * `React.lazy` attend un module à export DEFAULT, or tout le projet utilise des
 * exports nommés (`export function OrdersScreen`). Plutôt que d'ajouter un
 * `export default` à 41 fichiers — ce qui créerait deux façons d'importer le
 * même écran — ce helper fait la conversion à un seul endroit.
 *
 * Le nom de l'export est passé en chaîne : TypeScript vérifie qu'il existe bien
 * dans le module et qu'il s'agit d'un composant, donc une faute de frappe reste
 * une erreur de compilation.
 */
export function lazyScreen<K extends string>(
  loader: () => Promise<Record<K, ComponentType<unknown>>>,
  exportName: K,
) {
  return lazy(async () => {
    const module = await loader();
    return { default: module[exportName] };
  });
}
